import { render, staticRenderFns } from "./TypeOfCourseForRig.vue?vue&type=template&id=6080276c&"
import script from "./TypeOfCourseForRig.vue?vue&type=script&lang=js&"
export * from "./TypeOfCourseForRig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports